import { jsx as _jsx } from "react/jsx-runtime";
function SwitcherButton(props) {
    const { baseClass = "ms3-layer-switcher__button", // TODO: Use generic class name
    children, toggleActive, status, active, } = props;
    return (_jsx("button", { type: "button", role: "checkbox", "aria-checked": active ? "true" : "false", className: `${baseClass} ${baseClass}--${status}`, onClick: toggleActive, children: children }));
}
export default SwitcherButton;
